export const extract = (licence) => {
    if (licence && licence.content) {
        let el = document.createElement( 'html');
        el.innerHTML = licence.content;
        const bookmarks = Array.from(el.querySelectorAll( 'a[id]'));

        return bookmarks.map(b => {
            return {
                id: b.id,
                // Bookmark anchors are inserted before the heading text
                name: b.nextSibling.textContent
            };
        });
    }

    return [];
};